module.exports = __webpack_public_path__ + "static/samImage-1a912d160beaeff8c93739941b5c6b58.jpg";